export default {
      id: "ic_rapid_market_circle-usage",
      viewBox: "0 0 13 15",
      url: "/" + "images/icons.3.109.2.svg#ic_rapid_market_circle-usage",
      toString: function () {
        return this.url;
      }
    }